// Global Values
var qtyMinus = document.getElementsByClassName ('js-qty__adjust--minus'),
    qtyPlus = document.getElementsByClassName ('js-qty__adjust--plus'),
    qtyValueInput = document.getElementsByClassName ('js-qty__num'), 
    currentVal,
    prod_vars = $(".product-variant-selection"),
    prod_price = '$' + $(prod_vars[0]).find('.variant__price').text().replace(/[^0-9.-]+/g,"");

// Activates the side-cart for the subnav header
$(document).on("click", "#subnav_cart_icon", function(e){
  // Prevent the button from triggering its default action
  e.preventDefault();
  addToCartOk();
});

// Fixes a dom load error, where the text doesn't display on the "preorder" button.
function domButtonLoad() {
  setTimeout(function(){
    $('.btn--add-to-cart').find("span").text("Pre-order");
  }, 100);
}

// Fixes a random style from being applie by default on the product video modal (08/5/24 - @MMJ)
$(document).ready(function(){
  $('div').each(function(){
	if($(this).attr('data-remodal-id') === 'product-video-modal'){
		$(this).attr('style', '');
	} 
  })
})

// Changes the cart button to either an "add-to-cart" or "pre-order" button
function changeCartBtn(type) {
  let btn = $('.btn--add-to-cart');
  if(type === 'pre-order') {
    btn.addClass("pre-order po_btn");
    btn.removeClass("atc_btn");
    btn.find("img").attr("data-src", "//www.jigsawhealth.com/cdn/shop/t/146/assets/preorder.svg?v=36631765436880140311786480653");
    btn.find("img").attr("src", "//www.jigsawhealth.com/cdn/shop/t/146/assets/preorder.svg?v=36631765436880140311786480653");
    domButtonLoad();
    $('.pre-order-description').show();
  } else if(type === 'add-to-cart') {
    btn.addClass("atc_btn");
    btn.removeClass("pre-order po_btn");
    btn.find("img").attr("data-src", "//www.jigsawhealth.com/cdn/shop/t/146/assets/cart--black.svg?v=152469390788106803271786480466");
    btn.find("img").attr("src", "//www.jigsawhealth.com/cdn/shop/t/146/assets/cart--black.svg?v=152469390788106803271786480466");
  }
}

// Change "Add to Cart" button to "Pre-order" button
function determineCartBtn() {
 $(document).ready(function(){
  // Will change the add-to-cart button to a pre-order button if the default item on page load is a pre-order product.
  if($('.product-variant-selection-radio--preorder').attr('checked') === 'checked') {
      changeCartBtn('pre-order');
  }
   
  // If the site is single product page and the product is a pre-order, then change the button.
  if(document.querySelector('.template-product') && document.querySelector('.advanced') === null
     && $('.buy-box__right').attr('data-option') === 'pre-order') {
      changeCartBtn('pre-order');
  }

   // If the user clicks on a product that is a pre-order (multi-product page), then change the button to a preorder button.
   $(document).on("click", ".product-variant-selection--preorder", function(){
      changeCartBtn('pre-order');
      
   });
  
   // If the user clicks on a product that is normal (multi-product page), then change the button to an add-to-cart button.
   $(document).on("click", ".product-variant-selection--available", function(){
      changeCartBtn('add-to-cart');
   });
 });
}

// Resets the prices on the buy box
function resetPrices() {
  $('#Quantity').val(1); 
  $('#ProductPrice2').text(`${prod_price}`);
  $('#ComparePrice').text(`$${Number((prod_price).replace(/[^0-9.-]+/g,"")) + (5.03)}.00`);
  generateBuyBox();
}

function valueUpdateWrapper() {
  // Disable all minus buttons on product archive to start
  $(".template-collection .js-qty__adjust--minus").addClass("js-qty__disable");  
  
  // Process the selector arrays above to add events to all elements in the Dom
  for (var i = 0; i < qtyMinus.length; i++) {
    qtyMinus[i].addEventListener('click', updateSiblingValueMinus);
  }
  for (var i = 0; i < qtyPlus.length; i++) {
    qtyPlus[i].addEventListener('click', updateSiblingValuePlus);
  }
  for (var i = 0; i < qtyValueInput.length; i++) {
    qtyValueInput[i].addEventListener('input', updateValue);
  }

  function updateValue(e) {
    currentVal = e.target.value;
    if(currentVal > 1) {
      $(this).siblings('.js-qty__adjust--minus').removeClass("js-qty__disable");
    } else {
      $(this).siblings('.js-qty__adjust--minus').addClass("js-qty__disable");
    }
  }

  function updateSiblingValueMinus(e) {
    currentVal = $(this).siblings('input').val();
    if(currentVal == 2) {
      $(this).addClass("js-qty__disable");
    }
  }

  function updateSiblingValuePlus(e) {
    currentVal = $(this).siblings('input').val();
    if(currentVal >= 1) {
      $(this).siblings('.js-qty__adjust--minus').removeClass("js-qty__disable");
    }
  }
};

valueUpdateWrapper();

// Product archive ajax
"use strict";
var Ajaxinate=function(e){var t=e||{};this.settings=Object.assign({pagination:".AjaxinatePagination",method:"scroll",container:".AjaxinateLoop",offset:0,loadingText:"Loading more of your favorites...",callback:null},t),this.addScrollListeners=this.addScrollListeners.bind(this),this.addClickListener=this.addClickListener.bind(this),this.checkIfPaginationInView=this.checkIfPaginationInView.bind(this),this.stopMultipleClicks=this.stopMultipleClicks.bind(this),this.destroy=this.destroy.bind(this),this.containerElement=document.querySelector(this.settings.container),this.paginationElement=document.querySelector(this.settings.pagination),this.initialize()};Ajaxinate.prototype.initialize=function(){this.containerElement&&{click:this.addClickListener,scroll:this.addScrollListeners}[this.settings.method]()},Ajaxinate.prototype.addScrollListeners=function(){this.paginationElement&&(document.addEventListener("scroll",this.checkIfPaginationInView),window.addEventListener("resize",this.checkIfPaginationInView),window.addEventListener("orientationchange",this.checkIfPaginationInView))},Ajaxinate.prototype.addClickListener=function(){this.paginationElement&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.clickActive=!0,null!==this.nextPageLinkElement&&this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks))},Ajaxinate.prototype.stopMultipleClicks=function(e){e.preventDefault(),this.clickActive&&(this.nextPageLinkElement.innerHTML="<img src=\"//www.jigsawhealth.com/cdn/shop/t/146/assets/loading-gif.gif?v=115431\" /> Loading more of your favorites...",this.nextPageUrl=this.nextPageLinkElement.href,this.clickActive=!1,this.loadMore())},Ajaxinate.prototype.checkIfPaginationInView=function(){var e=this.paginationElement.getBoundingClientRect().top-this.settings.offset,t=this.paginationElement.getBoundingClientRect().bottom+this.settings.offset;e<=window.innerHeight&&t>=0&&(this.nextPageLinkElement=this.paginationElement.querySelector("a"),this.removeScrollListener(),this.nextPageLinkElement&&(this.nextPageLinkElement.innerHTML='<img style="max-width: 250px;" src="" /> Loading more of your favorites...',this.nextPageUrl=this.nextPageLinkElement.href,this.loadMore()))},Ajaxinate.prototype.loadMore=function(){this.request=new XMLHttpRequest,this.request.onreadystatechange=function(){if(4===this.request.readyState&&200===this.request.status){var e=this.request.responseXML.querySelectorAll(this.settings.container)[0],t=this.request.responseXML.querySelectorAll(this.settings.pagination)[0];this.containerElement.insertAdjacentHTML("beforeend",e.innerHTML),this.paginationElement.innerHTML=t.innerHTML,this.settings.callback&&"function"==typeof this.settings.callback&&this.settings.callback(this.request.responseXML),this.initialize(),valueUpdateWrapper()}}.bind(this),this.request.open("GET",this.nextPageUrl),this.request.responseType="document",this.request.send()},Ajaxinate.prototype.removeClickListener=function(){this.nextPageLinkElement.addEventListener("click",this.stopMultipleClicks)},Ajaxinate.prototype.removeScrollListener=function(){document.removeEventListener("scroll",this.checkIfPaginationInView),window.removeEventListener("resize",this.checkIfPaginationInView),window.removeEventListener("orientationchange",this.checkIfPaginationInView)},Ajaxinate.prototype.destroy=function(){return{click:this.removeClickListener,scroll:this.removeScrollListener}[this.settings.method](),this};

function headerStick() {
  let subNav = $('#subnav-header').offset(),
  $window = $(window);

  if(subNav !== undefined) {
    $window.scroll(function() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() > subNav.top-3700 || $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
      else {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() > subNav.top || $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
    }); 
  }
}

if ($('#shopify-section-product-template').length) {
  headerStick();
}

if($('#shopify-section-bundle-products-buy-box').length) {
  headerStick();
}

// Remove home hero video completely from DOM to resolve new IOS picking up the video file on mobile safari 7/2021
function hideHomeHeroVideoMobile() {
  $('.home-hero__video').remove();
}
if($(window).width() < 768) {
  hideHomeHeroVideoMobile();
}


//if(newVal = 1)$(".js-qty__adjust--minus").addClass("js-qty__disable");
//if (currentVal = 1) ? $(".js-qty__adjust--minus").addClass("js-qty__disable");

// Handlebar.js helpers
// if equal
Handlebars.registerHelper('ifeq', function (a, b, options) {
  if (a == b) { return options.fn(this); }
  return options.inverse(this);
});
// if not equal
Handlebars.registerHelper('ifnoteq', function (a, b, options) {
  if (a != b) { return options.fn(this); }
  return options.inverse(this);
});

// greater than
Handlebars.registerHelper('gt', function( a, b ){
  var next =  arguments[arguments.length-1];
  return (a > b) ? next.fn(this) : next.inverse(this);
});
// less than or equal to
Handlebars.registerHelper('le', function( a, b ){
  var next =  arguments[arguments.length-1];
  return (a <= b) ? next.fn(this) : next.inverse(this);
});
// add 2 variables
Handlebars.registerHelper('add', function( a, b ){
  if (isNumber(a) && isNumber(b)) {
    return Number(a) + Number(b);
  }
  if (typeof a === 'string' && typeof b === 'string') {
    return a + b;
  }
  return '';
});
Handlebars.registerHelper("log", function(something) {
});
// Fix mini cart price
Handlebars.registerHelper('fixPrice', function(str, discount) {
  var num = Number(str.replace(/[^0-9.-]+/g,""));
  num = num * 100;
  var price = num + discount;
  price = (price / 100).toFixed(2);
  price = "$" + price;
  return price;
});


// Mini Cart slider js
var i = 0;
function move() {
  if (i == 0) {
    i = 1;
    var elem = document.getElementById("myBar");
    var width = 1;
    var id = setInterval(frame, 10);
    function frame() {
      if (width >= 100) {
        clearInterval(id);
        i = 0;
      } else {
        width++;
        elem.style.width = width + "%";
      }
    }
  }
}

// AOS animations
AOS.init({
  duration: 400,
  offset: -100,
  easing: 'ease-in-out-quart',
  delay: 200,
  disable: 'mobile',
  once: 'true',
});

// Product variant page load selector (pull variant id from url)
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};

variantId = getUrlParameter('variant');
if(variantId == null) {
  variantId = $('.product-variant-selection:first').find('div.variantId').attr('id')
}

/*** FireFly Quote Slider ***/
$('#firefly-quote-slider').slick({
    dots: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true
  });

/******** Advanced Product Gallery Modal RT -  2025 ********/
// Mobile hero slider
(function ($) {
  if (!document.querySelector('[data-mobile-hero-slider="1"]')) return;

  function getActiveWrap() {
    return $('.product_hero__media-wrap').first();
  }

  // Everything below only works once the gallery is actually visible/measurable
  // (e.g. it's display:none on desktop where .d-sm-only hides it). Wrapped in
  // boot() so we can retry after a resize/orientation change instead of
  // permanently giving up if the page happened to load on desktop first.
  function boot() {
  let $main = getActiveWrap().find('.product_hero__media--slider');
  let $nav  = getActiveWrap().find('.product_hero__media--nav');

  if (!$main.length || !$nav.length) return false;

  // Initialize (or re-initialize) the slick sliders for the currently active variant wrap.
  // Safe to call even if one of the two is already slick-initialized (e.g. a prior
  // call partially failed) — each slider is only ever handed to .slick() once.
  function initSlickFor($m, $n) {
    const mAlready = $m.hasClass('slick-initialized');
    const nAlready = $n.hasClass('slick-initialized');

    if (mAlready && nAlready) return;

    // Must be bound BEFORE .slick() runs: Slick fires 'init' synchronously
    // from inside the .slick() call, so binding afterward misses it.
    if (!mAlready) $m.on('init.heroSlick', function(){ $(this).removeClass('js-slick-pending'); });
    if (!nAlready) $n.on('init.heroSlick', function(){ $(this).removeClass('js-slick-pending'); });

    if (!mAlready) {
      $m.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: true,
        adaptiveHeight: false,
        infinite: false,
        asNavFor: $n
      });

      // Firefox: Slick attaches a mousedown listener to .slick-list in bubble phase.
      // Delegated (document-level) stopPropagation is too late — Slick already ran.
      // Direct listeners on the video element fire first and stop bubbling before
      // Slick's drag-tracker sees them, so shouldClick stays true and preventDefault
      // is never called on the play/pause click.
      $m.find('video').each(function () {
        this.addEventListener('mousedown', function (e) { e.stopPropagation(); });
        this.addEventListener('mouseup',   function (e) { e.stopPropagation(); });
      });
    }

    if (!nAlready) {
      $n.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: $m,
        // focusOnSelect is unreliable here (asNavFor pairing against a jQuery
        // object that gets re-queried per variant silently swallows Slick's
        // internal click-to-select in this codebase — see the same
        // workaround already used for the desktop gallery in
        // activateVariantSlider()). Drive slide changes explicitly instead
        // of depending on it.
        focusOnSelect: false,
        infinite: false,

        // The strip's scrolling is handled by plain CSS (overflow-x: auto on
        // .slick-list, transform disabled on .slick-track — see
        // product-hero-rt-component.css) rather than Slick's own drag/swipe
        // engine, so it behaves like an ordinary scrollable row instead of a
        // paged carousel. draggable/swipe/touchMove must all stay off: even
        // with draggable false, Slick's touchMove engine still tracks
        // mouse/touch drags and snaps to the nearest slide on release. It
        // can't actually animate anything (the CSS's forced `transform:
        // none` blocks that), but the snap attempt is what made the strip
        // feel like it was jumping between thumbnails instead of scrolling
        // smoothly. Touch scrolling works fine natively via overflow-x:auto
        // without Slick's help; mouse dragging is handled by the plain
        // scrollLeft listener below.
        draggable: false,
        swipe: false,
        touchMove: false,
        accessibility: true,
        centerMode: false
      });

      // Mouse users get no drag-to-scroll for free: touchMove above only
      // covers touch input, and Slick's own draggable can't be turned on
      // (see comment above — it fights the forced transform:none by trying
      // to animate the track via transform). Wire up plain scrollLeft
      // dragging on the .slick-list instead, mouse-only.
      (function () {
        const listEl = $n.find('.slick-list')[0];
        if (!listEl) return;

        let isDown = false;
        let startX = 0;
        let startScrollLeft = 0;
        let moved = false;

        listEl.addEventListener('mousedown', function (e) {
          // Without this, mousedown on an <img> starts the browser's native
          // ghost-image drag. That steals mousemove away from this listener
          // mid-drag, which is what made the scroll feel like it was
          // jumping instead of tracking the cursor.
          e.preventDefault();

          isDown = true;
          moved = false;
          startX = e.pageX;
          startScrollLeft = listEl.scrollLeft;
          listEl.classList.add('slick-dragging');
        });

        window.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          const dx = e.pageX - startX;
          if (Math.abs(dx) > 3) moved = true;
          listEl.scrollLeft = startScrollLeft - dx;
        });

        window.addEventListener('mouseup', function () {
          if (!isDown) return;
          isDown = false;
          listEl.classList.remove('slick-dragging');
        });

        // Suppress the thumbnail's click-to-select once a drag actually
        // moved the strip, so releasing the mouse after a drag doesn't
        // also jump the main slider to whatever thumbnail sits under it.
        listEl.addEventListener(
          'click',
          function (e) {
            if (moved) {
              e.stopPropagation();
              e.preventDefault();
            }
          },
          true
        );
      })();
    }

    // Guard against zero-width slide measurement when init happens in the
    // same tick as showing a previously display:none wrap (variant switch).
    // Deferred a frame so layout has actually settled before Slick re-measures
    // (measuring in the same tick the wrap becomes visible is what left the
    // real slide scrolled out of view, i.e. a blank first image).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        $m.slick('setPosition');
        $n.slick('setPosition');
      });
    });

    // Manually drive the main slider from a thumbnail tap instead of relying
    // on focusOnSelect (see note above).
    if (!nAlready) $n.on('click.heroSlick', '.slick-slide', function (e) {
      e.preventDefault();

      const mainSlick = $m.slick('getSlick');
      // Slick stamps data-slick-index once, in buildOut(), which only runs on
      // the slider's original .slick() init — slickFilter/slickUnfilter's
      // reinit() never re-stamps it. So after filtering to a variant, this
      // attribute still holds each slide's position from the very first,
      // unfiltered slide list, not its current one — using it (even modulo
      // the current slide count) points at the wrong slide once the gallery
      // has ever been filtered. Read the slide's actual current position in
      // the live DOM instead.
      const index = $(this).closest('.slick-track').children('.slick-slide').index(this);
      if (mainSlick && index > -1) {
        $m.slick('slickGoTo', index);
      }
    });
  }

  initSlickFor($main, $nav);

  // Gallery is a single product-wide slick instance (hero-mobile.liquid
  // renders one deduped wrap instead of one per variant) — a variant switch
  // never destroys/rebuilds a slider or toggles wrapper display (that cycle
  // was the actual cause of the dots never rendering). Instead it uses
  // Slick's own built-in slickFilter/slickUnfilter API, which detaches
  // non-matching slides and runs Slick's internal reinit() — the same
  // tested routine Slick itself uses for addSlide/removeSlide. Each slide
  // carries data-variant-ids="123 456" (space-separated, since one media
  // item can belong to more than one variant even though it's only
  // rendered once) — see hero-mobile.liquid.
  //
  // slickFilter needs the full slide set already in the DOM (that's what it
  // caches internally on first call), so cache references to it now, before
  // any filtering happens, purely to sanity-check "does this variant have
  // any images" before filtering — infinite:false means Slick never clones
  // slides, so these references stay valid for the life of the page.
  const $allMainSlides = $main.find('.product_hero__media__slide');

  function filterToVariant(vid) {
    if (vid == null) return;
    const selector = '[data-variant-ids~="' + vid + '"]';

    // Guard against filtering to zero slides (bad data / variant genuinely
    // has no gallery images) — slickFilter with an empty result set leaves
    // Slick with a 0-slide track, which breaks it. Leave the gallery as-is.
    if (!$allMainSlides.filter(selector).length) return;

    $main.stop(true).fadeTo(120, 0, function () {
      // slickFilter caches whatever is CURRENTLY in the track as the set it
      // filters from, not the true original full set — so filtering twice in
      // a row (variant A, then variant B) filters B's selector against only
      // A's already-narrowed slides. Since two variants' slides are usually
      // disjoint, that matches nothing and empties the slider. slickUnfilter
      // restores the full set first every time (a no-op if nothing was ever
      // filtered, since it checks its own cache before doing anything).
      $main.slick('slickUnfilter');
      $nav.slick('slickUnfilter');
      $main.slick('slickFilter', selector);
      $nav.slick('slickFilter', selector);

      // reinit() (called internally by slickFilter) only clamps currentSlide
      // if it's now out of bounds for the new slide count — it does not reset
      // to 0. So switching from e.g. slide 4 of variant A to variant B (which
      // also has >=4 slides) would silently land on B's 4th image instead of
      // its first. Force both sliders back to the start every time.
      $main.slick('slickGoTo', 0, true);
      $nav.slick('slickGoTo', 0, true);

      $main.stop(true).fadeTo(120, 1);
    });
  }

  $(document).on('click', '.product-variant-selection', function () {
    filterToVariant($(this).data('variant-id'));
  });

  // Land on just the initially selected variant's images instead of the
  // full union on first paint.
  const initialVariantId = $main.closest('.product_hero__media-wrap').attr('data-initial-variant-id');
  if (initialVariantId) {
    const selector = '[data-variant-ids~="' + initialVariantId + '"]';
    if ($allMainSlides.filter(selector).length) {
      $main.slick('slickFilter', selector);
      $nav.slick('slickFilter', selector);
    }
  }

  // The rest of the slides are marked loading="lazy" (see hero-mobile.liquid)
  // so they don't compete with the active variant's images on first paint —
  // but that means the browser hasn't fetched them at all yet, so the first
  // variant switch would otherwise stall on a real network fetch. Once the
  // page is idle, quietly warm the browser's HTTP cache for every other
  // slide's image so switching variants later is instant.
  function prefetchOtherVariantImages() {
    const seen = {};
    $allMainSlides.each(function () {
      const img = this.querySelector('img[src]');
      if (!img || seen[img.src]) return;
      seen[img.src] = true;
      const pre = new Image();
      pre.src = img.src;
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetchOtherVariantImages, { timeout: 3000 });
  } else {
    setTimeout(prefetchOtherVariantImages, 1500);
  }

  return true;
  } // end boot()

  // jigsaw.js is a deferred <head> script, but this section's own stylesheet
  // (product-hero-rt-component.css / bundle-product-hero-rt-component.css) is
  // linked from inside the section markup in <body>. A deferred script only
  // blocks on stylesheets that precede it in the document, so this script can
  // run before that CSS has loaded/applied — meaning $main's real width
  // (100% of its wrap, via the mobile-only CSS) isn't in effect yet. Calling
  // boot() at that point makes Slick measure the unstyled container and bake
  // a bogus tiny inline width onto every slide permanently. Poll for a
  // sane measured width before booting instead of assuming CSS already won
  // the race.
  function waitForMeasurableWidth(attemptsLeft) {
    const el = getActiveWrap().find('.product_hero__media--slider')[0];
    const width = el ? el.getBoundingClientRect().width : 0;

    // Below ~50px the container is still unstyled (or genuinely hidden on
    // desktop, where boot() itself no-ops via the empty-length check above).
    if (width > 50 || attemptsLeft <= 0) {
      boot();
      return;
    }

    requestAnimationFrame(function () {
      waitForMeasurableWidth(attemptsLeft - 1);
    });
  }

  waitForMeasurableWidth(60);

  // Slick's re-measurement after a hidden->visible CSS flip (desktop<->mobile,
  // via .d-sm-only) is unreliable here no matter how it's re-triggered — so
  // stop trying to repair it live. EVERY time the viewport actually crosses
  // INTO mobile (a real resize/orientation transition, not the initial page
  // load), just reload. A fresh load always boots clean, every time, not
  // just the first.
  (function () {
    const mq = window.matchMedia('(max-width: 719px)');
    const onChange = function (e) {
      if (e.matches) location.reload();
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else {
      mq.addListener(onChange);
    }
  })();

})(jQuery);

// End mobile slider settings

// Desktop hero product gallery
function getVariantIdFromElement(element) {
    // Get the class list
    var classes = element.className.split(/\s+/);

    // Look for class starting with "variant-"
    for (var i = 0; i < classes.length; i++) {
        if (classes[i].startsWith("variant-")) {
            // Extract and return the numeric part
            return classes[i].replace("variant-", "");
        }
    }

    // If not found
    return null;
}

function activateVariantSlider(variantId) {
    const $slider = $('.variant-' + variantId + '.product-gallery-slider');
    const $nav = $('.variant-' + variantId + '.product-gallery-slider-nav');

    if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            draggable: false,
            adaptiveHeight: true,
            rows: 0,
            asNavFor: '.variant-' + variantId + '.product-gallery-slider-nav'
        });
    } else {
        $slider.slick('refresh');
    }

    if (!$nav.hasClass('slick-initialized')) {
        $nav.slick({
            slidesToShow: 20,
            slidesToScroll: 1,
            arrows: false,
            draggable: false,
            swipe: false,
            accessibility: false,
            centered: false,
            rows: 0,
            asNavFor: '.variant-' + variantId + '.product-gallery-slider'
        });
    } else {
        $nav.slick('refresh');
    }

    // click handler that replaces focusOnSelect behavior
    $nav.on('click', '.slick-slide', function (e) {
      // If your thumbs contain links/buttons, prevent navigation:
      e.preventDefault();

      const slickMain = $slider.slick('getSlick');
      const slideCount = slickMain.slideCount;

      // data-slick-index can be negative/duplicated when infinite/clones are involved
      const rawIndex = parseInt($(this).attr('data-slick-index'), 10);
      const index = ((rawIndex % slideCount) + slideCount) % slideCount;

      $slider.slick('slickGoTo', index);
    });
}

function hideNonCurrentVariantElements() {
    // Get the current variant class (e.g., "variant-39371877679182")
    const currentVariantClass = $('.product-gallery-dropdown #dropdown_list li.current')
        .attr('class')
        .split(' ')
        .find(c => c.startsWith('variant-'));

    if (!currentVariantClass) return;

    // Select all elements that have a variant-XXXX class, excluding the dropdown list items
    $('#modal_gallery [class*="variant-"]').not('.product-gallery-dropdown #dropdown_list li').each(function () {
        const classes = $(this).attr('class').split(/\s+/);
        const hasVariantClass = classes.find(c => c.startsWith('variant-'));

        if (hasVariantClass && hasVariantClass !== currentVariantClass) {
            $(this).hide(); // Hide if it's not the current
        } else if (hasVariantClass === currentVariantClass) {
            $(this).show(); // Show current
        }
    });
}

function setupVariantSelector() {
    $('#dropdown_list li').on('click', function () {
        // Step 1: Update `.current` class in dropdown
        $('.product-gallery-dropdown #dropdown_list li').removeClass('current').attr('aria-selected', 'false');
        $(this).addClass('current').attr('aria-selected', 'true');

        // Step 2: Get the selected variant ID class (e.g., 'variant-39371877679182')
        const selectedVariantClass = $(this)
            .attr('class')
            .split(/\s+/)
            .find(c => c.startsWith('variant-'));

        if (!selectedVariantClass) return;

        // Step 3: Show only elements with the selected variant class
        $('#modal_gallery [class*="variant-"]').not('.product-gallery-dropdown #dropdown_list li').each(function () {
            const elementClasses = $(this).attr('class').split(/\s+/);
            const elementVariant = elementClasses.find(c => c.startsWith('variant-'));

            if (elementVariant === selectedVariantClass) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        // Step 4: Extract just the ID and activate the sliders
        const variantId = selectedVariantClass.replace('variant-', '');
        activateVariantSlider(variantId);
    });
}

// Configure the mobile product gallery lightbox
(function ($) {
  const $lightbox = $('#product-gallery-lightbox');
  const $body = $lightbox.find('.pglb__body');

  if (!$('.product_hero__media--slider').length || !$lightbox.length) return;

  function getActiveSlider() {
    return $('.product_hero__media-wrap').first().find('.product_hero__media--slider');
  }

  function openLightbox(targetMediaId) {
    // Build gallery from the current slides (keeps same media + order)
    const itemsHtml = getActiveSlider().find('.product_hero__media__slide').map(function () {
      const $slide = $(this);
      const mediaId = $slide.attr('data-media-id') || '';
      const mediaType = $slide.attr('data-media-type') || '';

      // Grab the rendered media element inside the slide (img/video/etc.)
      // Clone it so we don't move it out of the slider
      const $mediaEl = $slide.find('img, video, model-viewer, iframe').first().clone();

      // Improve UX: don’t autoplay videos in the stacked gallery
      if ($mediaEl.is('video')) {
        $mediaEl.prop('controls', true);
        $mediaEl.prop('autoplay', false);
        $mediaEl.prop('muted', true);
        $mediaEl.attr('playsinline', '');
      }

      // Ensure images aren’t lazy in the modal scroll area (optional)
      if ($mediaEl.is('img')) {
        $mediaEl.attr('loading', 'eager');
        $mediaEl.attr('decoding', 'async');
      }

      const outer = document.createElement('div');
      outer.className = 'pglb__item';
      outer.setAttribute('data-media-id', mediaId);
      if ($mediaEl.length) outer.appendChild($mediaEl.get(0));

      return outer.outerHTML;
    }).get().join('');

    $body.html(itemsHtml);

    // Open
    $lightbox.addClass('is-open').attr('aria-hidden', 'false');
    document.documentElement.classList.add('pglb-locked');
    document.body.classList.add('pglb-locked');

    // Focus the scroll container (accessibility)
    $body.focus();

    // Scroll to the clicked media’s position
    if (targetMediaId) {
      const $target = $body.find(`[data-media-id="${targetMediaId}"]`);
      if ($target.length) {
        // Use scrollIntoView so it lands “where the clicked image was” visually
        $target.get(0).scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }
  }

  function closeLightbox() {
    $lightbox.removeClass('is-open').attr('aria-hidden', 'true');
    document.documentElement.classList.remove('pglb-locked');
    document.body.classList.remove('pglb-locked');
    $body.empty();
  }

  // Click on main slider media → open lightbox at that media
  $(document).on('click', '.product_hero__media--slider .product_hero__media__slide', function (e) {
    // Ignore if user clicked a link/button inside
    if ($(e.target).closest('a, button').length) return;
    // Video slides play inline — don't hijack native video controls
    if ($(this).attr('data-media-type') === 'video' || $(this).attr('data-media-type') === 'external_video') return;

    const mediaId = $(this).attr('data-media-id');
    openLightbox(mediaId);
  });

  // Close button
  $lightbox.on('click', '.pglb__close', function () {
    closeLightbox();
  });

  // Click outside body (optional close)
  $lightbox.on('click', function (e) {
    if ($(e.target).is('#product-gallery-lightbox')) closeLightbox();
  });

  // ESC closes
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $lightbox.hasClass('is-open')) {
      closeLightbox();
    }
  });

})(jQuery);


/******** Gallery Modal 2025 (END) ********/

(() => {
  'use strict';

  document.addEventListener('click', (e) => {
    try {
      const wrapper = e.target.closest('.product_grid_img--wrapper');
      if (!wrapper) return;

      // ✅ your code here

    } catch (err) {
      console.error('[product_grid_img--wrapper click] error:', err);
    }
  });
})();


// Initialize on modal open
$(document).on('opening', '.remodal', function () {
    const $current = $('.product-gallery-dropdown #dropdown_list li.current');
    const variantId = getVariantIdFromElement($current[0]);
    if (variantId) {
        hideNonCurrentVariantElements();
        activateVariantSlider(variantId);
    }
});

// Initialize dropdown interactions
$(document).ready(function () {
    setupVariantSelector();
});

// Show dynamic info tied to variant in url paramter
//$('.product-page-buy-box-slider-wrap').css({'opacity':0,'z-index':0,'position':'absolute'});

if(!document.querySelector('.advanced-products')) {
  if($('.product-variant-selection').length) {
  $('.product-page-buy-box-slider-wrap.variant-' + variantId).css({'opacity':1,'z-index':1, 'position':'relative'});
  $('.variant-' + variantId + ':not(.btn--add-to-cart)').show();
  $('.btn--add-to-cart.variant-' + variantId).css({"display":"flex"});
  
  // Product variant selector
  
  $('.product-variant-selection').click(function(){
    variantId = $(this).find('div.variantId').attr('id');
  
    $('.product-page-buy-box-slider-wrap').css({'opacity':0,'z-index':0,'position':'absolute'});
    $('.variant-hide').hide();
    $('.product-page-buy-box-slider-wrap.variant-' + variantId).css({'opacity':1,'z-index':1,'position':'relative'});
    $('.variant-' + variantId + ':not(.btn--add-to-cart)').show();
    $('.btn--add-to-cart.variant-' + variantId).css({"display":"flex"});
    prod_price = $(this).find('.variant__price').text();
  });
  } else {
    $('.product-page-buy-box-slider-wrap').css({'opacity':1,'z-index':1, 'position':'relative'});
  }
}

//Figuring out time of all slider functions
// Bundle Product page code
// Multi product showcase for bundles
var multiProductShowcase = document.getElementById ('shopify-section-bundle-products-multi-product-showcase');
var multiProductShowcase_variants = document.getElementById ('shopify-section-bundle-multi-product-showcase--splash_page');

if (document.body.contains( multiProductShowcase ) || document.body.contains(multiProductShowcase_variants) ||  document.querySelector("#ingredients.showcase")) {
  var slidesToShowBundle = 6;
  var infiniteBundle = true;
  var childElementsBundle = $('.showcase__bottom').children().length;
  // Check if we can fulfill the preferred slidesToShow
  if( slidesToShowBundle > (childElementsBundle-1) ) {
    // Otherwise, make slidesToShow the number of slides - 1
    // Has to be -1 otherwise there is nothing to scroll for - all the slides would already be visible
    slidesToShowBundle = (childElementsBundle);

    if( slidesToShowBundle == 0) {
      slidesToShowBundle = 1;
      infinite = false;
    }

    // Adjusts the image padding at the bottom to prevent the title from bleeding over the image. This usually happens on a product slider with only four or less images. - @MMJ (11/6/24)
    if( childElementsBundle <= 4 ) {
      $('.bundle-products #ingredients .showcase__bottom__content img').css("padding-bottom", "40px");
    }
  }

  $('.showcase__top').slick({
    slidesToShow: slidesToShowBundle,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.showcase__bottom',
    draggable: false,
    //   autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: true
  });
  $('.showcase__bottom').slick({
    slidesToShow: slidesToShowBundle,
    slidesToScroll: 1,
    asNavFor: '.showcase__top',
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false
        }
      },
      {
        breakpoint: 676,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });
  $(window).resize(function(){
    $('.showcase__top')[0].slick.refresh();
    $('.showcase__bottom')[0].slick.refresh();
  });
}

// slider
// $slick_slider = $('.social-proof__slider');
// settings_slider = {
//   dots: false,
//   arrows: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   adaptiveHeight: true,
//   // more settings
// }
// slick_on_mobile( $slick_slider, settings_slider);

// // slick on mobile
// function slick_on_mobile(slider, settings){
//   $(window).on('load resize', function() {
//     if ($(window).width() > 767) {
//       if (slider.hasClass('slick-initialized')) {
//         slider.slick('unslick');
//       }
//       return
//     }
//     if (!slider.hasClass('slick-initialized')) {
//       return slider.slick(settings);
//     }
//   });
// };

// //Social Proof slider for bundle products, products, home page, and sales funnel
// //Only active on mobile devices
// var socialProof = document.getElementById ('shopify-section-social-proof');
// if (document.body.contains( socialProof ) ) {
//   // slick on mobile
//   function slick_on_mobile(slider, settings){
//     $(window).on('load resize', function() {
//       if ($(window).width() > 767) {
//         if (slider.hasClass('slick-initialized')) {
//           slider.slick('unslick');
//         }
//         return
//       }
//       if (!slider.hasClass('slick-initialized')) {
//         return slider.slick(settings);
//       }
//     });
//   };
// }

// Featured Product slider block
$('.featured-product__slider').slick({
  dots: false,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 676,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


// Health leader reviews sliders
// Set preferred slidesToShow
  var slidesPerRowLargeHealth = 4;
  var slidesPerRowMediumHealth = 3;
  var slidesPerRowSmallHealth = 1;
  var childReviewsElementsHealth = $('.social-proof-rt__slider').children('.social-proof-rt__col').length;
  // Check if we can fulfill the preferred slidesToShow
  if( slidesPerRowLargeHealth > childReviewsElementsHealth ) {
    // Otherwise, make slidesToShow the number of slides - 1
    // Has to be -1 otherwise there is nothing to scroll for - all the slides would already be visible
    slidesPerRowLargeHealth = childReviewsElementsHealth;
    slidesPerRowMediumHealth = (childReviewsElementsHealth-1);

    if( slidesPerRowLargeHealth == 2) {
      slidesPerRowLargeHealth = 2;
      slidesPerRowMediumHealth = 2;
      slidesPerRowSmallHealth = 2;
    }

    // If only 1 slide, then return just a single slide
    if( slidesPerRowLargeHealth == 1 < 2) {
      slidesPerRowLargeHealth = 1;
      slidesPerRowMediumHealth = 1;
      slidesPerRowSmallHealth = 1;
    }
  } 

  $('.social-proof-rt__slider').slick({
  rows: 2,
  slidesPerRow: slidesPerRowLargeHealth,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        rows: 2,
        slidesPerRow: slidesPerRowMediumHealth,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 720,
      settings: {
        rows: 2,
        slidesPerRow: slidesPerRowSmallHealth,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 

// Featured reviews sliders
// Set preferred slidesToShow
  var slidesPerRowLarge = 4;
  var slidesPerRowMedium = 2;
  var slidesPerRowSmall = 1;
  var childReviewsElements = $('.featured-reviews__slider').children('.featured-reviews__slide').length;
  // Check if we can fulfill the preferred slidesToShow
  if( slidesPerRowLarge > childReviewsElements ) {
    // Otherwise, make slidesToShow the number of slides - 1
    // Has to be -1 otherwise there is nothing to scroll for - all the slides would already be visible
    slidesPerRowLarge = childReviewsElements;
    slidesPerRowMedium = (childReviewsElements-1);

    if( slidesPerRowLarge == 2) {
      slidesPerRowLarge = 2;
      slidesPerRowMedium = 2;
      slidesPerRowSmall = 2;
    }

    // If only 1 slide, then return just a single slide
    if( slidesPerRowLarge == 1 < 2) {
      slidesPerRowLarge = 1;
      slidesPerRowMedium = 1;
      slidesPerRowSmall = 1;
    }
  } 

  var $reviewsSlider = $('.featured-reviews__slider');
  var slidesPerPage = 1;

  $reviewsSlider.slick({
    rows: 2,
    slidesPerRow: slidesPerRowLarge,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          rows: 2,
          slidesPerRow: slidesPerRowMedium,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 720,
        settings: {
          rows: 2,
          slidesPerRow: slidesPerRowSmall,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  setTimeout(function() {
    var totalPages = $reviewsSlider.slick('getSlick').slideCount;

    var paginationHtml = '<div class="featured-reviews__pagination"><button class="featured-reviews__pagination__btn featured-reviews__pagination__first" data-page="0">First</button><button class="featured-reviews__pagination__btn featured-reviews__pagination__prev">←</button><div class="featured-reviews__pagination__numbers">';
    paginationHtml += '<button class="featured-reviews__pagination__number featured-reviews__pagination__number--prev" data-page="0">1</button>';
    paginationHtml += '<button class="featured-reviews__pagination__number featured-reviews__pagination__number--current active" data-page="0">2</button>';
    paginationHtml += '<button class="featured-reviews__pagination__number featured-reviews__pagination__number--next" data-page="0">3</button>';
    paginationHtml += '</div><button class="featured-reviews__pagination__btn featured-reviews__pagination__next">→</button><button class="featured-reviews__pagination__btn featured-reviews__pagination__last" data-page="' + (totalPages - 1) + '">Last</button></div>';

    $reviewsSlider.after(paginationHtml);

    var $firstBtn = $('.featured-reviews__pagination__first');
    var $lastBtn = $('.featured-reviews__pagination__last');
    var $prevNavBtn = $('.featured-reviews__pagination__prev');
    var $nextNavBtn = $('.featured-reviews__pagination__next');
    var $prevPageBtn = $('.featured-reviews__pagination__number--prev');
    var $currentPageBtn = $('.featured-reviews__pagination__number--current');
    var $nextPageBtn = $('.featured-reviews__pagination__number--next');

    function updatePaginationUI(currentSlide) {
      var currentPage = Math.min(currentSlide + 1, totalPages);

      if (currentPage === 1) {
        $prevPageBtn.text('').data('page', null).addClass('featured-reviews__pagination__number--empty');
        $currentPageBtn.text(currentPage).data('page', 0).removeClass('featured-reviews__pagination__number--empty');
        $nextPageBtn.text(currentPage + 1).data('page', currentPage).removeClass('featured-reviews__pagination__number--empty');
      } else if (currentPage === totalPages) {
        $prevPageBtn.text(currentPage - 1).data('page', currentPage - 2).removeClass('featured-reviews__pagination__number--empty');
        $currentPageBtn.text(currentPage).data('page', currentPage - 1).removeClass('featured-reviews__pagination__number--empty');
        $nextPageBtn.text('').data('page', null).addClass('featured-reviews__pagination__number--empty');
      } else {
        $prevPageBtn.text(currentPage - 1).data('page', currentPage - 2).removeClass('featured-reviews__pagination__number--empty');
        $currentPageBtn.text(currentPage).data('page', currentPage - 1).removeClass('featured-reviews__pagination__number--empty');
        $nextPageBtn.text(currentPage + 1).data('page', currentPage).removeClass('featured-reviews__pagination__number--empty');
      }
    }

    var $pageNumbers = $('.featured-reviews__pagination__number');
    $pageNumbers.on('click', function() {
      if ($(this).hasClass('featured-reviews__pagination__number--empty')) return;
      var page = $(this).data('page');
      $reviewsSlider.slick('slickGoTo', page);
    });

    $firstBtn.on('click', function() {
      $reviewsSlider.slick('slickGoTo', 0);
    });

    $lastBtn.on('click', function() {
      $reviewsSlider.slick('slickGoTo', totalPages - 1);
    });

    $prevNavBtn.on('click', function() {
      $reviewsSlider.slick('slickPrev');
    });

    $nextNavBtn.on('click', function() {
      $reviewsSlider.slick('slickNext');
    });

    $reviewsSlider.on('afterChange', function(event, slick, currentSlide) {
      var newTotalPages = slick.slideCount;
      if (newTotalPages !== totalPages) {
        totalPages = newTotalPages;
      }
      updatePaginationUI(currentSlide);
    });

    $(window).on('resize', function() {
      var newTotalPages = $reviewsSlider.slick('getSlick').slideCount;
      if (newTotalPages !== totalPages) {
        totalPages = newTotalPages;
        updatePaginationUI($reviewsSlider.slick('slickCurrentSlide'));
      }
    });

    updatePaginationUI(0);
  }, 100); 

// Jigsaw Story Slider
var smallStorySlider = document.querySelector('.jigsaw-story');
if (document.body.contains( smallStorySlider ) ) {
  $('.jigsaw-story__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // Jigsaw Story Small Slider
  $('.jigsaw-story-small__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    adaptiveHeight: false,
  });
}

//product showcase slider 
//utilizing a media query to not allow elevatezoom to run on mobile
$('.showcase').find('.showcase__slide:eq(0)').show();
$('.showcase').find('.showcase__nav__slide:eq(0)').addClass('active');
var showCase = document.getElementById ('ingredients');
if (document.body.contains( showCase ) ){
  if (window.matchMedia('(min-width: 767px)').matches) {
    $('.showcase').find('#zoom_0').elevateZoom({tint:true, tintColour:'#000', tintOpacity:0.3});
  }
}
$('.showcase__nav__slide').on('click',function(){
  $('.zoomContainer').remove();
  $('.showcase__slide').hide();

  var count = $(this).attr('data-count');

  $('.showcase__nav__slide').removeClass('active');
  $(this).addClass('active');
  $('.showcase__slide-'+count).fadeIn();
  if (window.matchMedia('(min-width: 767px)').matches) {
    $('.showcase').find('#zoom_'+count).elevateZoom({tint:true, tintColour:'#000', tintOpacity:0.3});
  }
});
//elevate zoom on bundle ingredients 
//setting zoom on default products and variants seperately so the default image does not override the zoom image on the variant
$('.showcase__bottom__slide').on('click',function(){
  var count = $(this).attr('data-attribute-zoom');
  $('.zoomContainer').remove();

  if (window.matchMedia('(min-width: 767px)').matches) {
    $('.showcase').find('#zoom_'+count).elevateZoom({tint:true, tintColour:'#000', tintOpacity:0.3});
  } 
});
$('.variant__showcase__bottom__slide').on('click',function(){
  var count = $(this).attr('data-attribute-zoom');
  $('.zoomContainer').remove();

  if (window.matchMedia('(min-width: 767px)').matches) {
    $('.showcase').find('#zoom_variant_'+count).elevateZoom({tint:true, tintColour:'#000', tintOpacity:0.3});
  }
});

// Bundle FAQ block
$('.bundle-products__faq__product-select').first().addClass('active');
$('.bundle-products__faq__product-select').first().attr('aria-selected', 'true');
$('.showcase__faq__slide').first().fadeIn();
$('.bundle-products__faq__product-select').on('click', function() {
  $('.bundle-products__faq__product-select').attr('aria-selected', 'false');
  $(this).attr('aria-selected', 'true');
  $('.bundle-products__faq__product-select').removeClass('active');
  $(this).addClass('active');

  // Show variant FAQs and hide all others
  variantId = $(this).attr('data-id');
  $('.showcase__faq__slide').hide();
  $('.faq-'+variantId).fadeIn();
});

// ADA Fix to Accordion by Bret on 11/16/22 
var headers;

window.addEventListener('DOMContentLoaded', function() {
  headers = document.querySelectorAll('.drop-down-block__drop-down button');
  
  // Toggle the visibility of each panel when their respective header buttons are activated
  headers.forEach(function(header) {
    header.addEventListener('click', function() {
      // Flip aria-expanded to indicate the new state of the panel
      var isExpanded = header.getAttribute('aria-expanded') == 'true' ? true : false;
      header.setAttribute('aria-expanded', !isExpanded);
      
      // Animate the panel transition between expanded/collapse
      $('#' + header.getAttribute('aria-controls')).slideToggle();
    });
  });
});


$('.drop-down-block__header').stick_in_parent();

// ADA Fix to Accordion on Breaking Pickleball page
var breakPick;

window.addEventListener('DOMContentLoaded', function() {
  breakPick = document.querySelectorAll('.purchase-block__wrap__button button');
  
  // Toggle the visibility of each panel when their respective header buttons are activated
  breakPick.forEach(function(breakingP) {
    breakingP.addEventListener('click', function() {
      // Flip aria-expanded to indicate the new state of the panel
      var isExpanded = breakingP.getAttribute('aria-expanded') == 'true' ? true : false;
      breakingP.setAttribute('aria-expanded', !isExpanded);
      
      // Animate the panel transition between expanded/collapse
      $('.purchase-block__wrap__panel#' + breakingP.getAttribute('aria-controls')).slideToggle();
      $('.purchase-block__wrap__panel#' + breakingP.getAttribute('aria-controls')).toggleClass('active');
    });
  });
});

// ADA Fix to Accordion by Bret on 11/16/22 
var introHeaders;

window.addEventListener('DOMContentLoaded', function() {
  introHeaders = document.querySelectorAll('.product-intro__drop-down button');
  
  // Toggle the visibility of each panel when their respective header buttons are activated
  introHeaders.forEach(function(introHeader) {
    introHeader.addEventListener('click', function() {
      // Flip aria-expanded to indicate the new state of the panel
      var isExpanded = introHeader.getAttribute('aria-expanded') == 'true' ? true : false;
      introHeader.setAttribute('aria-expanded', !isExpanded);
      
      // Animate the panel transition between expanded/collapse
      $('#' + introHeader.getAttribute('aria-controls')).slideToggle();
    });
  });
});


// Product Buy Box
// Bundle Price Box
function bundlePriceBoxFunction() {
  var compareAtPriceSum = 0;
  $('.bundle-price__product').each(function(){
    compareAtPriceSum += parseFloat($(this).attr('data-compare-at-price'));  // Or this.innerHTML, this.innerText
  });
  var salePriceSum = 0;
  $('.bundle-price__product').each(function(){
    salePriceSum += parseFloat($(this).attr('data-original-price'));  // Or this.innerHTML, this.innerText
  });

  // Currency formatting function
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  // Format the numbers to currency
  var compareAtPriceSumFormatted = formatter.format(compareAtPriceSum);
  var salePriceSumFormatted = formatter.format(salePriceSum);

  // Output the formated values in the bundle buy box price
  $('.bundle-products .product-single__price--compare-at').text(compareAtPriceSumFormatted);
  $('.bundle-products .product-single__price--compare-at').attr('content', compareAtPriceSumFormatted);
  $('.bundle-products .product-single__price').text(salePriceSumFormatted);
  $('.bundle-products .product-single__price').attr('content', salePriceSumFormatted);
  $('.bundle-products .grid-product__price').text(salePriceSumFormatted);
}

bundlePriceBoxFunction();
//document.getElementById("shopify-section-bundle-products-hero").onload = function() {bundlePriceBoxFunction()}

function productArray(id, quantity) {
  this.id = id;
  this.quantity = quantity;
}

// Product Variant Image Slider
$('.product-page-buy-box-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  adaptiveHeight: true,
  draggable: false,
  asNavFor: '.product-page-buy-box-slider-nav'
});
$('.product-page-buy-box-slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.product-page-buy-box-slider',
  centerMode: true,
  arrows: false,
  infinite: false,
  focusOnSelect: true
});

// Safari iOS fix: adaptiveHeight measures height before image loads.
// Recalculate once the video slide's featured image finishes loading.
(function() {
  var $img = $('.product-page-buy-box-slider .product_video_modal_wrap .product-single__featured');
  if (!$img.length) return;
  var recalc = function() {
    $('.product-page-buy-box-slider').slick('setPosition');
  };
  if ($img[0].complete) {
    recalc();
  } else {
    $img.one('load', recalc);
  }
})();

// Apparel Product Variant Image Slider
$('.apparel-product-page-buy-box-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  asNavFor: '.apparel-product-page-buy-box-slider-nav'
});
$('.apparel-product-page-buy-box-slider-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.apparel-product-page-buy-box-slider',
  centerMode: true,
  infinite: true,
  arrows: false,
  focusOnSelect: true
});

//In place to hide monthly banner on the sales funnel page, per Jigsaw's order
var salesFunnelElementSelector = document.getElementById('shopify-section-sales-funnel-hero');
if (salesFunnelElementSelector != null) {
  $('.monthly-promo-banner').addClass('hidebanner');
}

const pushbar = new Pushbar({
  blur:true,
  overlay:true,
});

// Pushbar menu parent dropdown menu on click
$('.pushbar .parent--has-child').on('click', function() {
  $(this).toggleClass('.parent--open');
  $(this).find('.mobile-menu--child').slideToggle();
});

$('#NavMenu--Panel .parent--has-child').on('click', function() {
  $(this).toggleClass('.parent--open');
  $(this).find('.mobile-menu--child').slideToggle();
});


// Look for .hamburger
var hamburger = document.querySelector(".hamburger");

if(hamburger) {
  // On click
  hamburger.addEventListener("click", function() {
    // Toggle class "is-active"
    hamburger.classList.toggle("is-active");
    // Do something else, like open/close menu
  });
}

// ADA compliant Mega Menu - Malkin Made 12/15/25
window.addEventListener('DOMContentLoaded', function () {
  const navbar = document.querySelector('.header__left__navigation');
  if (!navbar) return;

  const mouseOutHideDelay = 0;

  // Find all dropdown <li> triggers
  const dropdowns = navbar.querySelectorAll('ul > li.jig-site-nav--has-dropdown');

  // Build a controller object for each dropdown
  const controllers = Array.from(dropdowns).map((triggerContainer) => {
    const triggerButton = triggerContainer.querySelector(':scope > button');
    const buttons = triggerContainer.querySelectorAll('.button');
    const lastMenuItem = buttons[buttons.length - 1] || null;

    let mouseOutTimer = null;
    let menuVisible = false;

    function showMenu() {
      if (!triggerButton) return;
      triggerButton.setAttribute('aria-expanded', 'true');
      menuVisible = true;
    }

    function hideMenu() {
      if (!triggerButton) return;
      triggerButton.setAttribute('aria-expanded', 'false');
      menuVisible = false;
    }

    function toggleMenu(e) {
      e.preventDefault();
      menuVisible ? hideMenu() : showMenu();
    }

    function triggerKeydownHandler(e) {
      // Hide when tabbing out from the last button, or on Escape
      if ((e.key === 'Tab' && !e.shiftKey && lastMenuItem && e.target === lastMenuItem) || e.key === 'Escape') {
        hideMenu();

        if (e.key === 'Escape' && triggerButton) {
          triggerButton.focus();
        }
      }
    }

    // Wire events (only if button exists)
    triggerContainer.addEventListener('mouseover', function () {
      showMenu();
      clearTimeout(mouseOutTimer);
    });

    triggerContainer.addEventListener('mouseout', function () {
      mouseOutTimer = setTimeout(hideMenu, mouseOutHideDelay);
    });

    triggerContainer.addEventListener('keydown', triggerKeydownHandler);

    if (triggerButton) {
      triggerButton.addEventListener('click', toggleMenu);
    }

    return { triggerContainer, triggerButton, showMenu, hideMenu, isOpen: () => menuVisible };
  });

  // Close any open menu when clicking outside the navbar
  document.body.addEventListener('click', function (e) {
    if (!navbar.contains(e.target)) {
      controllers.forEach((c) => c.hideMenu());
      return;
    }

    // Optional: close other menus when clicking a different trigger
    const clickedDropdown = e.target.closest('li.jig-site-nav--has-dropdown');
    if (clickedDropdown) {
      controllers.forEach((c) => {
        if (c.triggerContainer !== clickedDropdown) c.hideMenu();
      });
    }
  });
});





// Smooth Anchor Link Scrolling
$('.anchor-scroll').on('click', function(e) {
  e.preventDefault();

  // Store hash
  var hash = this.hash;
  var fixedHeaderOnScroll = $('.header').outerHeight();
  var subnavHeight = $('#subnav-header').outerHeight() - fixedHeaderOnScroll;

  $('html, body').animate({
    scrollTop: $(hash).offset().top+subnavHeight,
  }, 1200, function(){

  });
});

// Product Page Lightbox
$('.product-page-buy-box-slider a').simpleLightbox();

/*!
 * Bowser - a browser detectorthumbnails
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (typeof define == 'function' && define.amd) define(name, definition)
  else root[name] = definition()
    }(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
    , likeAndroid = /like android/i.test(ua)
    , android = !likeAndroid && /android/i.test(ua)
    , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
    , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
    , chromeos = /CrOS/.test(ua)
    , silk = /silk/i.test(ua)
    , sailfish = /sailfish/i.test(ua)
    , tizen = /tizen/i.test(ua)
    , webos = /(web|hpw)(o|0)s/i.test(ua)
    , windowsphone = /windows phone/i.test(ua)
    , samsungBrowser = /SamsungBrowser/i.test(ua)
    , windows = !windowsphone && /windows/i.test(ua)
    , mac = !iosdevice && !silk && /macintosh/i.test(ua)
    , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
    , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
    , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
    , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
    , mobile = !tablet && /[^-]mobi/i.test(ua)
    , xbox = /xbox/i.test(ua)
    , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
        , yandexbrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
        name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
        , osname: 'Windows Phone'
        , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
        , msie: t
        , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
        , osname: 'Chrome OS'
        , chromeos: t
        , chromeBook: t
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
        , msedge: t
        , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
        , osname: 'Sailfish OS'
        , sailfish: t
        , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
        , seamonkey: t
        , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
        , firefox: t
        , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
        , silk: t
        , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
        , phantom: t
        , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
        , osname: 'BlackBerry OS'
        , blackberry: t
        , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
        , osname: 'WebOS'
        , webos: t
        , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
        , osname: 'Bada'
        , bada: t
        , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
        , osname: 'Tizen'
        , tizen: t
        , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
        , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
        , googlebot: t
        , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
      };
    }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
      tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
      mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
        (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
       ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
             (result.chrome && result.version < 20) ||
             (result.firefox && result.version < 20.0) ||
             (result.safari && result.version < 6) ||
             (result.opera && result.version < 10.0) ||
             (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
             || (result.chromium && result.version < 20)
            ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});

// Browser Classes
var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
               navigator.userAgent &&
               navigator.userAgent.indexOf('CriOS') == -1 &&
               navigator.userAgent.indexOf('FxiOS') == -1;

if (isSafari) {
  $('body').addClass('safari');
}

if( bowser.msie && bowser.version == 11 ) {
  $('body').addClass('ie-11');
}

if (/Edg/.test(navigator.userAgent)) {
  $('body').addClass('edge');
}


if (window.location.href.indexOf("/cart") > -1) {

  //Cart Page Countdown Timer
  var is_weekend =  function(){
    var dt = new Date();
    var timeRange = new Date().getUTCHours ();

    if(dt.getDay() == 6 || dt.getDay() == 0) {
      //console.log("It is the weekend");
      return;
    }
    else {
      //console.log("It is a week day");
      //console.log(timeRange);

      // Time is between 6am (11) - 3pm (21) AZ Time
      if (timeRange >= 11 && timeRange <= 19) {
        function getTimeRemaining(endtime) {
          const total = Date.parse(endtime) - Date.parse(new Date());
          const seconds = Math.floor((total / 1000) % 60);
          const minutes = Math.floor((total / 1000 / 60) % 60);
          const hours = Math.floor((total / (1000 * 60 * 60)) % 24);

          return {
            total,
            hours,
            minutes,
            seconds
          };
        }

        function initializeClock(id, endtime) {
          const clock = document.getElementById(id);
          const hoursSpan = clock.querySelector('.hours');
          const minutesSpan = clock.querySelector('.minutes');
          const secondsSpan = clock.querySelector('.seconds');

          function updateClock() {
            const t = getTimeRemaining(endtime);

            hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
            minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
            secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

            if (t.total <= 0) {
              clearInterval(timeinterval);
            }
          }

          updateClock();
          const timeinterval = setInterval(updateClock, 1000);
        }

        var d = new Date(),
            minutes = d.getMinutes().toString().length == 1 ? '0'+d.getMinutes() : d.getMinutes(),
            hours = d.getHours().toString().length == 1 ? '0'+d.getHours() : d.getHours(),
            months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

        const deadline = months[d.getMonth()]+' '+d.getDate()+' '+d.getFullYear()+' 19:00:00 UTC';

        initializeClock('cartClock', deadline);
      } else {
        $('#cartClock').remove();
      }
    }
  }

  is_weekend();
  //document.getElementById("cartClock").onload = function() {is_weekend()};
}

// Discount code in url
// Check if coupon cookie does not exists or is undefined

if(document.cookie.indexOf("sessionCoupon=") < 0) {

  // check the url query for ?coupon=COUPONCODE
  function getQueryVariable(parameter) {
    var searchString = window.location.search.substring(1);
    var params = searchString.split('&');
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split('=');
      if (decodeURIComponent(pair[0]) == parameter) {
        return decodeURIComponent(pair[1]);
      }
    }
  }

  var couponCode = getQueryVariable('discount');
  //console.log(couponCode);

  // Set Coupon Cookie only if not equal to undefined and not empty
  if (typeof couponCode !== 'undefined' && couponCode !== '') {
    setJigCookie('sessionCoupon', couponCode);
  }

  // Apply discount to Shopify session and show success modal
  if (typeof couponCode !== 'undefined' && couponCode !== '') {
    // Clear any prior removal of this code so it shows in the cart UI
    try {
      var removed = JSON.parse(sessionStorage.getItem('removedDiscounts') || '[]');
      sessionStorage.setItem('removedDiscounts', JSON.stringify(
        removed.filter(function(d) { return d !== couponCode.toLowerCase(); })
      ));
      // Remove blank discount injection from checkout form if present
      document.querySelectorAll('form[action="/cart"] input[data-discount-clear]')
        .forEach(function(el) { el.parentNode.removeChild(el); });
    } catch(e) {}

    // Actually apply the discount to Shopify's cart session
    fetch('/discount/' + encodeURIComponent(couponCode) + '?return_to=/', { credentials: 'same-origin' })
      .then(function() {
        if (typeof ajaxCart !== 'undefined') ajaxCart.load();
      });

    $('.remodal--discount-success__text__discount').html(couponCode);
    var options = {
      hashTracking: false,
    };
    var inst = $('[data-remodal-id=discountSuccess]').remodal(options);
    inst.open();
  }

  // Hide alert when start shopping button clicked
  $('.button-shop').click(function(){
    $('.alert-success').slideToggle();
  });
  $('.alert-dismiss').click(function(){
    $('.alert-success').slideToggle();
  });

  function setJigCookie(cookieName, cookieValue) {
    var now = new Date();
    var time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    document.cookie = cookieName + "=" + cookieValue + '; expires=' + now.toUTCString() +  ";path=/";
  }

}

function searchModal() {

  setTimeout(function(){ $('#search-bar').focus(); }, 500);

}


document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;    

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
})

// Adding role and aria-label to cookie consent banner for ADA compliance - Malkin Made 6/14/23
$(function() {
  $(window).bind('load', function() {
    $(".hs-cookie-notification-position-bottom").attr("aria-label", "cookie consent banner");
    $(".hs-cookie-notification-position-bottom").attr("role", "region");
  });
});

// Adding padding to main block for breaking pickleball countdown timer
if( $('.countdown-timer').length ) {
  paddingTop = $('.countdown-timer').outerHeight();
  $("main.main-content").css("padding-top", paddingTop);
}

/* Function for causing the mobile menu to display on hover */
$(document).ready(function() {
  $('#LoginRoute--mobile').hover(function() {
    $('#LoginNav--mobile').toggle();
  });

  $('#LoginNav--mobile').mouseleave(function() {
    $(this).hide();
  });
});


/* Hiding SMS banner on homepage for Wholesale */


//ADA Compliance making statement a focus
$('.statement-row__wrap').focus();

/******* RT 4.1 - 6.1 Deployment Update - @MM - 7/16/25 ******/ 

function loadingBuyBox(){
  // Grab the buy box frequnecy
  let bb_freq = $('.advanced-product .buy-box__right__frequency .loop-subscription-container'),
      ugc_banner = $('.advanced-products .buybox-rt__ugc-block');;

  // Determine if the buy box frequency is available, if not then run loading gif
  if(bb_freq) {
    let timer = setInterval(()=>{
      if(bb_freq.hasClass('loop-display-none')) {
        $('.buy-box__right__frequency').addClass('loading');
      } else {
        // Once buy box frequency is available, then hide it.
        $('.buy-box__right__frequency').removeClass('loading');
        clearInterval(timer);
      }
    }, 100); 
  }

  if(ugc_banner) {
    let timer = setInterval(()=>{
      if(ugc_banner.find('.buybox-ugc .slick-list').length !== 1) {
        ugc_banner.addClass('loading');
      } else if(ugc_banner.find('.buybox-ugc .slick-list').length !== 0){
        // Once buy box frequency is available, then hide it.
        $('.buybox-rt__ugc-block .product_rating--stars img').on('load', function(){
          ugc_banner.removeClass('loading');
          clearInterval(timer);
        });
      }
    }, 100); 
  }

  // End this function
  return 0;
}

loadingBuyBox();

/*** UGC Slider & Content ***/
let slide_cnt = ($('.ugc-card').length) + 1;
$('.buybox-ugc-slider').slick({
  slidesToShow: slide_cnt,
  slidesToScroll: slide_cnt,
  arrows: false,
  draggable: false,
  infinite: false,
  
  responsive: [
      {
        breakpoint: 1040,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          // adaptiveHeight: true,
          infinite: false,
          draggable: true,
          dots: true,
          // variableWidth: true
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          // adaptiveHeight: true,
          draggable: true,
          dots: true,
          // variableWidth: true
        }
      }
  ]
});

// Determine if the ugc modal slider exists in the dom and then mute the videos before autoplay

$(document).on('click', '.ugc-link', function (e) {
      // Once ugc modal slider is available, then mute videos.
      const selector = [
        'video.fslightbox-source',
        'video.fslightboxv',
        '.fslightbox-container video',
        '.fslightbox-slide video',
        '.fslightbox-source video' // handles class on parent wrapper
      ].join(',');

      document.querySelectorAll(selector).forEach(video => {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
      });

  });

function ugcActiveVideo(v, opt) {
  if(v) {
    if(opt === 'play') {
      v.currentTime = 0;
      v.play();
    } else if(opt === 'pause') {
      v.pause();
      ugcActiveVideo(v, 'reset') // Recursion to reset time.
    } else if(opt === 'reset') {
      v.currentTime = 0; // Optional: reset to start
    } else if(opt === 'mute') {
      v.volume = 0;
      v.muted = true;
      v.setAttribute('muted','')
    }
  }
}

function ugcAutoPlay() {
  let videos = document.querySelectorAll('.ugc-preview-vid'),
      pictures = document.querySelectorAll('.ugc-media-bg'),
      first_video = videos[0];
  
  if(videos) {
    videos.forEach((video)=>{
      // Mute all videos unless played through the modal;
      ugcActiveVideo(video, 'mute');

      // On hover allow videos to auto play.
      video.addEventListener('mouseenter', () => {
        ugcPauseAll();
        ugcActiveVideo(video, 'play');
        document.querySelector('.slick-current.ugc-card').classList.remove('slick-current');
        video.closest('.ugc-card').classList.add('slick-current');
      });

      video.addEventListener('mouseleave', () => {
        ugcActiveVideo(video, 'pause');
      });
      
      autoPlayOnScroll(document.querySelector('.buybox-ugc-slider'), video);
    })

    if(pictures) {
      pictures.forEach((pic)=>{
        pic.addEventListener('mouseenter', () => {
          ugcPauseAll();
          document.querySelector('.slick-current.ugc-card').classList.remove('slick-current');
          pic.closest('.ugc-card').classList.add('slick-current');
        });
      })
    }
  }
}

function ugcPauseAll() {
  let videos = document.querySelectorAll('.ugc-preview-vid');
  
  if(videos) {
    videos.forEach((video)=>{
        ugcActiveVideo(video, 'pause');
    })
  }
}

function determinePosition(t, pos) {
	let scrollPos = window.scrollY;
	let rect = t.getBoundingClientRect();
	
	if (pos === 'top') {
		return scrollPos + rect.top;
	} else if (pos === 'bottom') {
		return scrollPos + rect.bottom;
	}
	return null;
}


function autoPlayOnScroll(t, v) {
	if (!t || !v) return;

	const onScroll = () => {
		const scrollY = window.scrollY;
		const t_top = determinePosition(t, 'top');
		const t_btm = determinePosition(t, 'bottom');
		const viewBottom = scrollY + window.innerHeight;

		// Adjust this logic to match exactly when you want the element to activate
		if ((t_top - scrollY) > 0 && t_btm <= viewBottom) {
			t.classList.add('active-scroll');
            v.closest('.slick-current') ?  ugcActiveVideo(v, 'play') : "" 
		} else {
			t.classList.remove('active-scroll');
            ugcActiveVideo(v, 'pause');
		}
	};

	document.addEventListener('scroll', onScroll, { passive: true });
	// Trigger once on load
	onScroll();
}

ugcAutoPlay();

/*** UGC Slider & Content (END) ***/
function addModalID() {
  let all_modals = $('.remodal');
  if(all_modals) {
    all_modals.each(function(){
      
    })
  }
}

// ADA Compliance Script for Modals and Dropdown Navigation
function rt_modal_init() {
  // Add .rt-modal class to remodal elements if missing
  let all_modals = $('.remodal');
  if (all_modals) {
    all_modals.each(function () {
      if (!$(this).hasClass('rt-modal')) {
        $(this).addClass('rt-modal');
      }
    });
  }

  const modals = document.querySelectorAll('.rt-modal');

  if (modals.length) {
    modals.forEach((modal) => {
      modal.classList.add('rt-modal-initialized');

      // Modal focus logic
      rt_modal_focus(modal);

      // Utility function to get currently visible, focusable elements
      function getVisibleFocusableElements(container) {
        const elements = container.querySelectorAll(
          'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), video'
        );

        return Array.from(elements).filter((el) => {
          const style = window.getComputedStyle(el);
          return (
            el.offsetParent !== null &&
            style.visibility !== 'hidden' &&
            style.display !== 'none' &&
            el.closest('[aria-hidden="true"]') === null
          );
        });
      }

      // Keydown listener to trap focus inside modal
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') {
          const focusable = getVisibleFocusableElements(modal);
          if (!focusable.length) return;

          const firstEl = focusable[0];
          const lastEl = focusable[focusable.length - 1];

          adaGalleryModel();
          $('.product_grid_img--wrapper').click(() => {
            $('.product-video-modal').focus();
          });

          if (e.shiftKey && document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          } else if (!e.shiftKey && document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        } else if (e.key === 'Escape') {
          closeModal(modal);
        }
      });

      // Dropdown logic to refresh focus after dynamic content updates
      const dropdownOptions = document.querySelectorAll('.dropdown--selector .dropdown--list li');
      if (dropdownOptions.length) {
        dropdownOptions.forEach(option => {
          option.addEventListener('click', function () {
            setTimeout(() => {
              const focusable = getVisibleFocusableElements(modal);
              if (focusable.length) {
                focusable[0].focus();
              }
            }, 100);
          });
        });
      }

      // Close button
      const closeBtn = modal.querySelector('.rt-modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => closeModal(modal));
      }
    });
  }

  // Open modal triggers
  const openButtons = document.querySelectorAll('.rt-modal-open');
  openButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('data-modal-target');
      const modal = document.getElementById(targetId);
      if (modal) openModal(modal);
    });
  });

  // Modal open logic
  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    const focusable = modal.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), video'
    );
    if (focusable.length) focusable[0].focus();
    adaGalleryModel();
  }

  // Modal close logic
  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
  }

  // Adjust focus on modal btn
  function rt_modal_focus(modal) {
    let m = modal,
        m_id = m.dataset['remodalId'],
        t_id = "";

    $('button, a').each(function () {
      let curr_btn = $(this);

      if (this.dataset['remodalTarget'] === m_id) {
        t_id = this.dataset['remodalTarget'];
        curr_btn.click(() => {
          $(this).addClass('rmb--active');
        });
      }

      if (t_id.length && m_id === t_id) {
        $('.rt-modal .remodal-close').on('click', () => {
          $('.rmb--active').focus();
          $('.rmb--active').removeClass('rmb--active');
        });

        $('.rt-modal').on('keydown', function (e) {
          if (e.key === 'Escape') {
            $('.rmb--active').focus();
            $('.rmb--active').removeClass('rmb--active');
          }
        });
      }
    });
  }
}


document.addEventListener('DOMContentLoaded', rt_modal_init);

function adaDetermineCurrentSlide() {
  /*** ADA Compliance Fix: Add Aria-current to active slide, image, or element display - @MM - 7/14/2025 ***/
  $('.rt-modal-initialized .slick-slide').attr('aria-current', 'false');
  $('.rt-modal-initialized .slick-slide:first').attr('aria-current', 'true');

  $('.rt-modal-initialized .slick-slide').each(()=>{
    $(this).click(()=>{
      $('.slick-slide').attr('aria-current', 'false');
      if($(this).hasClass('slick-current')) {
        $(this).attr('aria-current', 'true');
      }
    })
  })
}

adaDetermineCurrentSlide();

function adaGalleryModel() {
  let gallery = document.querySelector('#product-gallery-modal');
  
  removeAllTabindex(gallery);
  $('#product-gallery-modal button').click(()=>{ removeAllTabindex(gallery) })
}

adaGalleryModel();

function removeAllTabindex(parent) {
  if (!parent || !(parent instanceof Element)) {
    return;
  }

  const elementsWithTabindex = parent.querySelectorAll('[tabindex]');
  
  elementsWithTabindex.forEach(el => {
    el.removeAttribute('tabindex');
  });
}

/*** ADA (#552) - Fixes focus issue when clicking on anchor links ***/
// Focus the user on the section that they smooth scroll to from a link.
function focusSectionFromLink(link) {
  const $link = $(link);

  if (!$link.is('a')) {
    console.error('Invalid link element');
    return;
  }

  const targetId = $link.attr('href');
  if (!targetId || !targetId.startsWith('#')) {
    console.warn('Link does not reference a valid ID');
    return;
  }

  const $target = $(targetId);
  if ($target.length) {
    if (!$target.is('[tabindex]')) {
      $target.attr('tabindex', '-1');
    }

    $target.focus();
  } else {
    console.warn(`No element found with selector ${targetId}`);
  }
}

// Allow all links to focus on the location that user smooth scrolls to.
function targetAllLinks() {
  $('a').on('click', function (e) {
    focusSectionFromLink(this);
  });
}

targetAllLinks();
/*** (END) ADA (#552) ***/

// Jigsaw Story Slider
var smallStorySlider = document.querySelector('.jigsaw-story-rt');
if (document.body.contains( smallStorySlider ) ) {
  $('.jigsaw-story-rt__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    accessibility: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  // Jigsaw Story Small Slider
  $('.jigsaw-story-small__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: false,
  });
}

$('.jigsaw-story-rt__slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    accessibility: false
});

// Jigsaw Orchard Slider
$('#orchard-slider__slider').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  autoplay: true,
  autoplaySpeed: 2000,
  infinite: true,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 690,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

// Queue Lightbox
$('.orchard-lp-slider__lightbox').simpleLightbox();

/*** Social Proof RT - Slider Mobile, Tablet, and Desktop ***/
// slider

// $slick_slider_rt = $('.social-proof-rt__slider');
// mobile_settings_slider_rt = {
//   dots: true,
//   arrows: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   rows: 1
//   // more settings
// }

// tablet_settings_slider_rt = {
//   dots: true,
//   arrows: true,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   rows: 2
//   // more settings
// }

// // slick on mobile
// function slick_on_mobile(slider, settings){
//   $(window).on('load resize', function() {
//     if ($(window).width() > 719) {
//       if (slider.hasClass('slick-initialized')) {
//         slider.slick('unslick');
//       }
//       return
//     }
//     if (!slider.hasClass('slick-initialized')) {
//       return slider.slick(settings);
//     }
//   });
// };

// // slick on mobile
// function slick_on_tablet(slider, settings){
//   $(window).on('load resize', function() {
//     if ($(window).width() > 1024) {
//       if (slider.hasClass('slick-initialized')) {
//         slider.slick('unslick');
//       }
//       return
//     }
//     if (!slider.hasClass('slick-initialized')) {
//       return slider.slick(settings);
//     }
//   });
// };

// slick_on_mobile( $slick_slider_rt, mobile_settings_slider_rt );
// slick_on_tablet( $slick_slider_rt, tablet_settings_slider_rt );

/*** Product - Why Better Functionality ***/
function wb_adjust_columns(targetSelector, lg_col, md_col, sm_col) {
  const colRegex = /\b(col-\d+|md-col-\d+|sm-col-\d+|lg-col-\d+)\b/g;

  const $el = $(targetSelector);

  if ($el.length) {
    let classAttr = $el.attr("class") || "";

    // Remove all col-* style classes
    classAttr = classAttr.replace(colRegex, '').replace(/\s+/g, ' ').trim();
    $el.attr("class", classAttr);

    // Add new column classes if values are provided
    if (lg_col) {
      $el.addClass(`col-${lg_col} lg-col-${lg_col}`);
    }
    if (md_col) {
      $el.addClass(`md-col-${md_col}`);
    }
    if (sm_col) {
      $el.addClass(`sm-col-${sm_col}`);
    }
  }
}

function wb_panel() {
  $('.product-wb__col--1 .product-wb__row--col').click(function(){
    $('.product-wb__col--1 .product-wb__wrapper').addClass('opened');
    $('.product-wb__col--1 .product-wb__wrapper').removeClass('closed');
    $('.product-wb__col--2').hide();
    wb_adjust_columns(document.querySelector('.product-wb__col--1'), 12, 10, 12);
  })

  $('.product-wb__col--1 .product-wb--close_btn').click(function(){
    $('.product-wb__col--1 .product-wb__wrapper').addClass('closed');
    $('.product-wb__col--1 .product-wb__wrapper').removeClass('opened');
    $('.product-wb__col--2').show();
    wb_adjust_columns(document.querySelector('.product-wb__col--1'), 5, 6, 12);
  })

  $('.product-wb__col--2 .product-wb__row--col').click(function(){
    $('.product-wb__col--2 .product-wb__wrapper').addClass('opened');
    $('.product-wb__col--2 .product-wb__wrapper').removeClass('closed');
    $('.product-wb__col--1').hide();
    wb_adjust_columns(document.querySelector('.product-wb__col--2'), 12, 10, 12);
  })

  $('.product-wb__col--2 .product-wb--close_btn').click(function(){
    $('.product-wb__col--2 .product-wb__wrapper').addClass('closed');
    $('.product-wb__col--2 .product-wb__wrapper').removeClass('opened');
    $('.product-wb__col--1').show();
    wb_adjust_columns(document.querySelector('.product-wb__col--2'), 5, 6, 12);
  })
}

wb_panel();

/*** Jigsaw 3.0 - Header & Side Cart ***/
// Navigation Menu - Tablet
function hideAllTabletMenu() {
  $('.mega-menu__dropdown').length ? $('.mega-menu__dropdown').hide() : "";
}

function activateTabletMenuPanel() {
  // Menu Btn on tablet
  $('#NavBtn--Tablet').click(function(){
    if($('#NavMenu--Panel').hasClass('activated')) {
      $('#NavMenu--Panel').removeClass('activated');
    } else {
      $('#NavMenu--Panel').addClass('activated');
      hideAllTabletMenu();
      $('.mega-menu--products').show();
    }
  });

  // Product Btn on Mega Menu - Tablet
  $('#MenuBtn--Products').click(function(){
    hideAllTabletMenu();
    $('.mega-menu--products').show();
  })
  // Blog Btn on Mega Menu - Tablet
  $('#MenuBtn--Blog').click(function(){
    hideAllTabletMenu();
    $('.mega-menu--blog').show();
  })
  // About Btn on Mega Menu - Tablet
  $('#MenuBtn--About').click(function(){
    hideAllTabletMenu();
    $('.mega-menu--about').show();
  })
}

function activateMobileMenu() {
  // Look for .hamburger
  var mobileNav = document.querySelector("#NavBtn--Mobile");
  // On click
  if(mobileNav) {
     mobileNav.addEventListener("click", function() {
      // Toggle class "is-active"
      mobileNav.classList.toggle("is-active");
      // Do something else, like open/close menu
     }); 
  }
}

activateMobileMenu();
activateTabletMenuPanel();

function showCartVariantDesc() {
  $('.ajaxcart__product-desc span').hide();

  $('.ajaxcart__product-desc').each(function() {
    let $descSpan = $(this);
    let varId = $descSpan.data("variant-id");

    // Find the hidden div that matches this variant id
    let $source = $(this).find('.variant--' + varId);

    if ($source.length) {
      // Copy content from hidden variant-meta div into the span
      $source.show();
    } else {
      // Optionally hide if there's no match
      $descSpan.hide();
    }
  });
}

$('.cart-link').on('click', showCartVariantDesc());

if($('.llm-collection-template').length !== 1) {
  // Featured Product slider block
  // Set preferred slidesToShow
  var slidesPerRowLargeFeaturedProd = 4;
  var childReviewsElementsFeaturedProd = $('.featured-product-rt__slider').find('.product-archive__col--slider').length;
  // Check if we can fulfill the preferred slidesToShow
  if( slidesPerRowLargeFeaturedProd > childReviewsElementsFeaturedProd ) {
    // Otherwise, make slidesToShow the number of slides - 1
    // Has to be -1 otherwise there is nothing to scroll for - all the slides would already be visible
    slidesPerRowLargeFeaturedProd = childReviewsElementsFeaturedProd;
    //console.log(slidesPerRowLargeFeaturedProd);
  } 
  $('.featured-product-rt__slider').slick({
    dots: false,
    arrows: true,
    slidesToShow: slidesPerRowLargeFeaturedProd,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 676,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

$('.llm-collection-template .featured-product-rt__slider').slick({
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  centered: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1040,
      settings: {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

$('.featured-reviews-rt__slider').slick({
  dots: false,
  arrows: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 

$('.bundle-product-sf--slider').slick({
  dots: true,
  arrows: false,
  speed: 300,
  infinite: true,
  draggable: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  accessibility: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 720,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 

// ADA compliant video transcript for IFTFG video
document.querySelector('.transcript-toggle').addEventListener('click', function () {
  const transcript = document.getElementById('video-transcript');
  const isExpanded = this.getAttribute('aria-expanded') === 'true';

  // Toggle aria-expanded
  this.setAttribute('aria-expanded', String(!isExpanded));

  // Show / hide transcript
  transcript.hidden = isExpanded;

  // Update button text
  if (!isExpanded) {
    this.textContent = 'Close transcript';
  } else {
    this.textContent = 'Open transcript';
  }
});



// ADA compliant slick slider dots
$('.slick-dots li.slick-active button').attr('aria-current', 'true');

$('.slick-slider').on('afterChange', function () {
  $('.slick-dots li button').removeAttr('aria-current');
  $('.slick-dots li.slick-active button').attr('aria-current', 'true');
});

$('.slick-slider').each(function () {
  const $slider = $(this);

  $slider.find('.slick-dots li button').each(function (index) {
    if (!$(this).data('sr-initialized')) {
      $(this)
        .attr('aria-label', 'Go to slide ' + (index + 1))
        .html('<span class="sr-only">Go to slide ' + (index + 1) + '</span>')
        .data('sr-initialized', true);
    }
  });
});





/*** Loading Bundle Box - UGC ***/
function loadingBundleBuyBox(){
  // Grab the buy box frequnecy
  let bundle_ugc_banner = $('.bundle-products .buybox-rt__ugc-block');

  // Determine if the buy box frequency is available, if not then run loading gif
  if(bundle_ugc_banner) {
    let timer = setInterval(()=>{
      if(bundle_ugc_banner.find('.buybox-ugc .slick-list').length !== 1) {
        bundle_ugc_banner.addClass('loading');
      } else if(bundle_ugc_banner.find('.buybox-ugc .slick-list').length !== 0 && $('.buybox-rt__ugc-block .product_rating--stars img').length !== 0){
        // Once buy box frequency is available, then hide it.
        bundle_ugc_banner.removeClass('loading');
        clearInterval(timer);
      }
    }, 100); 
  }

  // End this function
  return 0;
}

loadingBundleBuyBox();

/*** Video Modal Logic ***/
/** Video Modal - Auto Play On Open **/
// Attach event listener to all buttons with data-remodal-target
$("button[data-remodal-target]").on("click", function() {
  let target = $(this).attr("data-remodal-target"),
      target_modal = $(`div[data-remodal-id="${target}"]`);

      if(target_modal.length) {
        let video = target_modal.find('video'),
          close_btn = $(`div[data-remodal-id="${target}"] .remodal-close`);

          if(video.length) {
            video[0].play();
          }

          close_btn.on("click", function(){
            video[0].pause();
            video[0].currentTime = 0;
          })
      } 
});